<div
	[translate]="'presentation.app.common.dialog.meetingAlternative.date'"
	[translateParams]="{
		day:
			(notification$ | async)?.meeting?.startDate
			| date: 'fullDate':null:(locale$ | async),
		startHour:
			(notification$ | async)?.meeting?.startDate
			| date: 'shortTime':null:(locale$ | async),
		endHour:
			(notification$ | async)?.meeting?.endDate
			| date: 'shortTime':null:(locale$ | async),
		coach: ((notification$ | async)?.meeting?.coach$ | async)
	}"
	class="text-xl leading-normal font-medium text-center"
	style="margin: 30px 0"
></div>
<div
	class="
		flex
		mt-3
		md:items-center md:flex-row
		justify-between
		md:space-x-3 md:space-y-0
		space-y-3
		flex-col
	"
>
	<button
		[label]="
			'presentation.app.common.dialog.meetingAlternative.actions.reject'
				| translate
		"
		(click)="onRejectClick()"
		class="p-button-danger"
		icon="far fa-times-circle"
		pButton
	></button>
	<button
		[label]="
			'presentation.app.common.dialog.meetingAlternative.actions.change'
				| translate
		"
		(click)="onChangeClick()"
		icon="far fa-calendar-alt"
		pButton
	></button>
	<button
		[label]="
			'presentation.app.common.dialog.meetingAlternative.actions.accept'
				| translate
		"
		(click)="onAcceptClick()"
		class="p-button-success"
		icon="far fa-check-circle"
		pButton
	></button>
</div>
